import React, { useState } from 'react'
import { CircularProgress, Typography } from '@material-ui/core'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline'

function PlusMinusButton(props) {
  const { onChange, loading, max, disabled, defaultValue } = props
  const [value, setValue] = useState(defaultValue || 0)

  const onPlus = () => {
    if (disabled) return
    if (max !== 'undefined' && value >= max) {
      return
    }
    setValue(value + 1)
    if (onChange) {
      onChange(value + 1)
    }
  }

  const onMinus = () => {
    if (disabled) return
    if (value <= 0) {
      return
    }
    if (value > 0) {
      setValue(value - 1)
      if (onChange) {
        onChange(value - 1)
      }
    }
  }

  if (loading) return <CircularProgress size={10} />
    return (
      <>
        <AddCircleOutlineIcon fontSize='medium' onClick={onPlus} style={{ cursor: disabled ? 'not-allowed' : 'pointer', color: disabled ? '#888' : 'inherit' }} />
        <Typography component={'span'} variant='body1' style={{ margin: 10 }}>
          {value}
        </Typography>
        <RemoveCircleOutlineIcon fontSize='medium' onClick={onMinus} style={{ cursor: disabled ? 'not-allowed' : 'pointer', color: disabled ? '#888' : 'inherit' }} />
      </>
    )
}

export default PlusMinusButton
